import React from "react";
import ImageSlider from "/vercel/path0/src/components/ImageSlider";
const slides = [
  {url: "https://i.imgur.com/v7Oug9t.jpeg", title: "city", description: "There's a beauty to interconnected systems and the logic that ties everything together."},
  {url: "https://i.imgur.com/2mpkQje.gif", title: "golden", description: "Ideas and dreams gave shape to the world."},
  {url: "https://i.imgur.com/RlAx2yW.jpeg", title: "hope", description: "We must be better."}
]

function Home() {
  return (
    <div id="home" className="flexbox-container-v page-content">
      <div className="flexbox-container-v">

        <div id="SlideContainer">
          <ImageSlider slides={slides} parentWidth={900}/>
        </div>

        <div id="home-tags" className="tag-holder">

          <div id="FrontEnd-tag" className="content tiny-font">
            <p className="tag-info small-font">FrontEnd:</p>
            <div  className="flexbox-container-h">
              <span className="tag">HTML</span>
              <span className="tag">CSS</span>
              <span className="tag">JavaScript</span>
              <span className="tag">React.js</span>
              <span className="tag">Angular</span>
            </div>
          </div>

          <div id="Backend-tag" className="content">
            <p className="tag-info small-font">Backend:</p>
            <div  className="flexbox-container-h tiny-font">
              <span className="tag">API</span>
              <span className="tag">AWS</span>
              <span className="tag">Node.js</span>
              <span className="tag">Express.js</span>
              <span className="tag">GitHub</span>
              <span className="tag">MySQL</span>
              <span className="tag">PHP</span>
            </div>
          </div>

          <div id="Programming-tag" className="content tiny-font">
            <p className="tag-info small-font">Other Programming Languages:</p>
            <div  className="flexbox-container-h">
              <span className="tag">C#</span>
              <span className="tag">Java</span>
              <span className="tag">Kotlin</span>
              <span className="tag">GDScript</span>
            </div>
          </div>

          <div id="Modeling-tag" className="content tiny-font">
            <p className="tag-info small-font">3D Modeling:</p>
            <div  className="flexbox-container-h">
              <span className="tag">Blender</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Home;